import { type OptionsFetchQueryResult, OptionsType } from '@openx/types/options.ts';
import type { UseQueryOptions } from '@openx/types/reactQuery.ts';
import { useTranslation } from 'react-i18next';

import { useOptionsFetch } from './generics/useOptionsFetch.tsx';

export function useBrowserOptionsFetch(queryOptions?: UseQueryOptions<OptionsFetchQueryResult>) {
  const { t } = useTranslation();
  const {
    isLoading: isBrowserOptionsLoading,
    data: browsers,
    refetch: refetchBrowserOptions,
  } = useOptionsFetch({
    errorMessage: t('Failed to fetch browser options'),
    optionType: OptionsType.BROWSER,
    queryOptions,
  });

  return {
    browsers,
    isBrowserOptionsLoading,
    refetchBrowserOptions,
  };
}
